{
  "{account} needs to sign in again.": "{account} muss sich erneut anmelden.",
  "{account} no longer has access to Johku Hub.": "{account} hat keinen Zugang mehr zu Johku Hub.",
  "{done} of {total}": "{done} von {total}",
  "{left} of {total} left": "{left} von {total} übrig",
  "{n} by email": "{n} per E-Mail",
  "{n} by push": "{n} per Push",
  "{n} customer waiting for a reply": "{n} Kunde wartet auf Antwort",
  "{n} customers waiting for a reply": "{n} Kunden warten auf Antwort",
  "{n} let in on this phone": "{n} mit diesem Telefon eingelassen",
  "{n} message": "{n} Nachricht",
  "{n} message hasn't been sent yet and will be lost.": "{n} Nachricht wurde noch nicht gesendet und geht verloren.",
  "{n} messages": "{n} Nachrichten",
  "{n} messages haven't been sent yet and will be lost.": "{n} Nachrichten wurden noch nicht gesendet und gehen verloren.",
  "{n} more: search by name.": "{n} weitere: nach Namen suchen.",
  "{n} of {total}": "{n} von {total}",
  "{n} pcs": "{n} Stk.",
  "{n} shop chosen": "{n} Shop ausgewählt",
  "{n} shops chosen": "{n} Shops ausgewählt",
  "{n} ticket": "{n} Ticket",
  "{n} tickets": "{n} Tickets",
  "{n} unread": "{n} ungelesen",
  "{n} unread conversation": "{n} ungelesene Unterhaltung",
  "{n} unread conversations": "{n} ungelesene Unterhaltungen",
  "{n} use left": "Noch {n} Nutzung",
  "{n} uses left": "Noch {n} Nutzungen",
  "{name} ({n} member)": "{name} ({n} Mitglied)",
  "{name} ({n} members)": "{name} ({n} Mitglieder)",
  "{name} and {n} more": "{name} und {n} weitere",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} hat Ihnen in Johku Hub eine Nachricht geschickt ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} hat Ihnen in Johku Hub eine Nachricht geschickt.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} kann seine Produkte in deinem Vertriebskanal verkaufen. Sobald sie annehmen, setzt Johku es um.",
  "{shop} sent you a message about your order {order}.": "{shop} hat Ihnen eine Nachricht zu Ihrer Bestellung {order} geschickt.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} möchte mit euch sprechen. Antworte oder nimm an, um fortzufahren.",
  "{sold} of {seats} sold": "{sold} von {seats} verkauft",
  "A Bluetooth or USB scanner that types the code, as in the POS's ticket reader.": "Ein Bluetooth- oder USB-Scanner, der den Code eintippt, wie im Ticketleser der Kasse.",
  "About Johku": "Über Johku",
  "Accept": "Annehmen",
  "Accepted the offer: {channel}, {commission} % commission.": "Hat das Angebot angenommen: {channel}, {commission} % Provision.",
  "Accepted, being put into effect in Johku": "Angenommen, wird in Johku umgesetzt",
  "Accepted, but Johku couldn't put it into effect: {error}": "Angenommen, aber Johku konnte es nicht umsetzen: {error}",
  "Accepted, in effect in Johku": "Angenommen, in Johku aktiv",
  "Access and instructions": "Zugangs- und Nutzungshinweise",
  "Accounts": "Konten",
  "Accounts and settings": "Konten und Einstellungen",
  "Add account": "Konto hinzufügen",
  "Add an account": "Ein Konto hinzufügen",
  "All": "Alle",
  "All caught up": "Alles gelesen",
  "All incidents": "Alle Störungen",
  "All orders": "Alle Bestellungen",
  "All shops": "Alle Shops",
  "All your shops ({n})": "Alle Ihre Shops ({n})",
  "Allow": "Erlauben",
  "Allow {app} to use Johku Hub?": "{app} Zugriff auf Johku Hub geben?",
  "Already used": "Bereits verwendet",
  "an assistant": "ein Assistent",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "Ein Assistent möchte auf deine Unterhaltungen in Johku Hub zugreifen. Melde dich zuerst an.",
  "As {name}": "Als {name}",
  "Ask the shop": "Den Shop fragen",
  "Attach a file": "Datei anhängen",
  "Back": "Zurück",
  "Between organisations": "Zwischen Organisationen",
  "Booking": "Buchung",
  "Can't load the collections right now.": "Die Kollektionen können gerade nicht geladen werden.",
  "Can't load the list of organisations right now.": "Die Liste der Organisationen kann gerade nicht geladen werden.",
  "Can't reach Johku Hub. Check your connection and try again.": "Johku Hub ist nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "Cancel": "Abbrechen",
  "Cancelled": "Storniert",
  "Cause found, being fixed": "Ursache gefunden, wird behoben",
  "Check in": "Einchecken",
  "Check out": "Auschecken",
  "Check-in opens {time}.": "Der Check-in ist ab {time} möglich.",
  "Checked in {time}": "Eingecheckt {time}",
  "Checked out {time}": "Ausgecheckt {time}",
  "Checking in…": "Wird eingecheckt…",
  "Checking out…": "Wird ausgecheckt…",
  "Checking the ticket…": "Ticket wird geprüft…",
  "Choose a conversation": "Wählen Sie eine Unterhaltung",
  "Choose resources and start times": "Ressourcen und Startzeiten wählen",
  "Choose the seats to let in": "Plätze für den Einlass wählen",
  "Choose the shows to scan for": "Vorstellungen zum Scannen wählen",
  "Chosen shops": "Ausgewählte Shops",
  "Close": "Schließen",
  "Code sent to {email}": "Code gesendet an {email}",
  "Codes": "Codes",
  "Commission (%)": "Provision (%)",
  "Confirmed": "Bestätigt",
  "Conversation": "Unterhaltung",
  "Conversation with the shop": "Unterhaltung mit dem Shop",
  "Conversations with the Johku team and shops show up here.": "Unterhaltungen mit dem Johku-Team und mit Shops erscheinen hier.",
  "Copied": "Kopiert",
  "Copy the code": "Code kopieren",
  "customer": "Kunde",
  "Customer": "Kunde",
  "Decline": "Ablehnen",
  "Declined": "Abgelehnt",
  "Declined the offer.": "Hat das Angebot abgelehnt.",
  "Deny": "Ablehnen",
  "Done": "Erledigt",
  "Download": "Herunterladen",
  "Downloading {name}": "{name} wird heruntergeladen",
  "E.g. Card payments fail": "Z. B. Kartenzahlungen schlagen fehl",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Jedes Mitglied erhält sie in einer eigenen Unterhaltung mit dem Shop, und die Antworten kommen einzeln zu dir.",
  "Email address": "E-Mail-Adresse",
  "Email those who don't have the app": "E-Mail an alle ohne die App",
  "Event times, cancellations and the shop's replies.": "Veranstaltungszeiten, Absagen und die Antworten des Shops.",
  "Every shop": "Alle Shops",
  "Everything you've bought from Johku shops, in one place.": "Alles, was Sie in Johku-Shops gekauft haben, an einem Ort.",
  "Expired {date}": "Abgelaufen am {date}",
  "Find a shop": "Shop suchen",
  "Fixed, monitoring": "Behoben, wird beobachtet",
  "For": "Für",
  "For every shop": "Für alle Shops",
  "For: {shops}": "Für: {shops}",
  "Get started": "Erste Schritte",
  "Get told about new messages": "Über neue Nachrichten informiert werden",
  "Getting the shows…": "Vorstellungen werden geladen…",
  "Getting the tickets…": "Tickets werden geladen…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Gutscheine und andere Codes, die Sie in Johku-Shops kaufen, erscheinen hier.",
  "Hide": "Ausblenden",
  "Hide used and expired codes": "Benutzte und abgelaufene Codes ausblenden",
  "Home": "Start",
  "Hub may not use the camera. Allow it in the phone's settings.": "Hub darf die Kamera nicht verwenden. Erlauben Sie es in den Einstellungen des Telefons.",
  "In messages": "In Nachrichten",
  "Incidents": "Störungen",
  "Incidents in Johku": "Störungen bei Johku",
  "Investigating": "Wird untersucht",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "Er ist 10 Minuten gültig. Wenn Sie ihn nicht angefordert haben, können Sie diese E-Mail ignorieren.",
  "It opens signed in, and stays open in the background": "Sie wird angemeldet geöffnet und bleibt im Hintergrund offen",
  "It sees only what you see in Johku Hub, and every use is logged.": "Er sieht nur, was du in Johku Hub siehst, und jede Nutzung wird protokolliert.",
  "Johku account": "Johku-Konto",
  "Johku agreement": "Johku-Vertrag",
  "Johku App": "Johku App",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub funktioniert gerade nicht. Versuchen Sie es gleich noch einmal.",
  "Johku Hub sign-in code: {code}": "Johku Hub-Anmeldecode: {code}",
  "Johku status: {title}": "Johku-Status: {title}",
  "Kind of conversation": "Art der Unterhaltung",
  "Know when things change": "Wissen, wenn sich etwas ändert",
  "Language": "Sprache",
  "Let in {n}": "Einlassen ({n})",
  "Let in: {n} seat": "Eingelassen: {n} Platz",
  "Let in: {n} seats": "Eingelassen: {n} Plätze",
  "Light off": "Licht aus",
  "Light on": "Licht an",
  "Loading…": "Wird geladen…",
  "Main menu": "Hauptmenü",
  "Maintenance": "Wartung",
  "Make an offer": "Angebot machen",
  "Members of": "Mitglieder von",
  "Members' replies come as conversations of their own.": "Antworten der Mitglieder kommen als eigene Unterhaltungen.",
  "Message": "Nachricht",
  "Message (optional)": "Nachricht (optional)",
  "Message the seller about your order and get told when they reply.": "Schreiben Sie dem Shop zu Ihrer Bestellung und erfahren Sie, wenn eine Antwort kommt.",
  "Message to {shop}": "Nachricht an {shop}",
  "Message to the shops": "Nachricht an die Shops",
  "Messages": "Nachrichten",
  "Messages can't be reached right now.": "Die Nachrichten sind gerade nicht erreichbar.",
  "My Johku": "Mein Johku",
  "Name, sign-in and deleting the account": "Name, Anmeldung und Löschen des Kontos",
  "New conversation": "Neue Unterhaltung",
  "New incident": "Neue Störung",
  "New message from {name} in Johku Hub": "Neue Nachricht von {name} in Johku Hub",
  "New message from {shop}": "Neue Nachricht von {shop}",
  "New message: {shop}, order {order}": "Neue Nachricht: {shop}, Bestellung {order}",
  "New messages in Johku Hub": "Neue Nachrichten in Johku Hub",
  "Next up": "Als Nächstes",
  "No connection. Check the connection and try again.": "Keine Verbindung. Prüfen Sie die Verbindung und versuchen Sie es erneut.",
  "No conversations yet": "Noch keine Unterhaltungen",
  "No conversations yet. Start one with the pen above.": "Noch keine Unterhaltungen. Beginnen Sie eine mit dem Stift oben.",
  "No email? It can take a minute. Check the spam folder too.": "Keine E-Mail? Das kann eine Minute dauern. Sehen Sie auch im Spam-Ordner nach.",
  "No incidents in the last 30 days.": "Keine Störungen in den letzten 30 Tagen.",
  "No matches.": "Keine Treffer.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Noch keine Nachrichten zu dieser Bestellung. Der Kunde erhält eine E-Mail mit einem Link zur Bestellseite, wo er lesen und antworten kann.",
  "No messages yet": "Noch keine Nachrichten",
  "No messages yet.": "Noch keine Nachrichten.",
  "No shows match.": "Keine passenden Vorstellungen.",
  "No tickets start today for these.": "Für diese beginnen heute keine Tickets.",
  "No valid codes": "Keine gültigen Codes",
  "None of the shop's collections has members yet.": "Keine Kollektion des Shops hat bisher Mitglieder.",
  "Not a valid ticket": "Kein gültiges Ticket",
  "Not sent: {error}": "Nicht gesendet: {error}",
  "Not shown yet": "Noch nicht sichtbar",
  "Not working": "Funktioniert nicht",
  "Nothing matches “{query}”.": "Nichts passt zu „{query}“.",
  "Nothing to scan from today on.": "Ab heute gibt es nichts zu scannen.",
  "Notice": "Hinweis",
  "Notifications are blocked for this site in the browser's settings.": "Benachrichtigungen sind für diese Website in den Browsereinstellungen blockiert.",
  "Notifications are off for Johku Hub in the phone's settings.": "Benachrichtigungen für Johku Hub sind in den Telefoneinstellungen ausgeschaltet.",
  "Notifications of new messages: {name}": "Benachrichtigungen über neue Nachrichten: {name}",
  "Now": "Jetzt",
  "Offer a sales channel": "Vertriebskanal anbieten",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Angebot: Verkauft eure Produkte in {channel} mit {commission} % Provision.",
  "Offline": "Offline",
  "Offline. {n} message will send when the connection returns.": "Offline. {n} Nachricht wird gesendet, sobald die Verbindung zurück ist.",
  "Offline. {n} messages will send when the connection returns.": "Offline. {n} Nachrichten werden gesendet, sobald die Verbindung zurück ist.",
  "Offline. Messages will send when the connection returns.": "Offline. Nachrichten werden gesendet, sobald die Verbindung zurück ist.",
  "Offline. These are the codes saved on this phone ({time}).": "Offline. Dies sind die auf diesem Telefon gespeicherten Codes ({time}).",
  "Offline. These are the orders saved on this phone.": "Offline. Dies sind die auf diesem Telefon gespeicherten Bestellungen.",
  "Offline. These are the tickets saved on this phone ({time}).": "Offline. Dies sind die auf diesem Telefon gespeicherten Tickets ({time}).",
  "OK": "OK",
  "One use": "Einmal gültig",
  "Only for {name}: check their ID.": "Nur für {name}: Ausweis prüfen.",
  "Only the shop's users who can use the POS can scan its tickets.": "Nur Benutzer des Shops mit Zugriff auf die Kasse können seine Tickets scannen.",
  "Only your own sign-in: your shop and its Johku agreement are managed in Johku App.": "Nur Ihre eigene Anmeldung: Ihr Shop und sein Johku-Vertrag werden in der Johku App verwaltet.",
  "Open Johku App": "Johku App öffnen",
  "Open the order": "Bestellung öffnen",
  "Open the order in the shop": "Bestellung im Shop öffnen",
  "Opening…": "Wird geöffnet…",
  "Opens in a new tab": "Öffnet sich in einem neuen Tab",
  "Order": "Bestellung",
  "Order {id}": "Bestellung {id}",
  "Orders": "Bestellungen",
  "Other merchants": "Andere Händler",
  "Other merchants find {shop}": "Andere Händler finden {shop}",
  "Other orders": "Weitere Bestellungen",
  "Paid": "Bezahlt",
  "Partly working": "Funktioniert teilweise",
  "Pictures, PDF, text, Word and Excel files only": "Nur Bilder, PDF-, Text-, Word- und Excel-Dateien",
  "PIN code": "PIN-Code",
  "PIN codes": "PIN-Codes",
  "Point the camera at a ticket's code.": "Richten Sie die Kamera auf den Code eines Tickets.",
  "Privacy policy": "Datenschutzerklärung",
  "Private message": "Private Nachricht",
  "Questions about your order? The shop's answer comes to Messages.": "Fragen zu Ihrer Bestellung? Die Antwort des Shops kommt in Nachrichten.",
  "Read and reply: {url}": "Lesen und antworten: {url}",
  "Read and search your conversations": "Deine Unterhaltungen lesen und durchsuchen",
  "Reader settings": "Leser-Einstellungen",
  "Ready for the next ticket.": "Bereit für das nächste Ticket.",
  "Recent": "Neueste",
  "Recipient": "Empfänger",
  "Refunded": "Erstattet",
  "Reload": "Neu laden",
  "Remove": "Entfernen",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Antworte in der Johku-App oder unter {url}, angemeldet mit dieser E-Mail-Adresse.",
  "Resolved": "Gelöst",
  "Resolved: {title}": "Gelöst: {title}",
  "Resources": "Ressourcen",
  "Row {row}, seat {seat}": "Reihe {row}, Platz {seat}",
  "Sales channel offer": "Vertriebskanal-Angebot",
  "Save": "Speichern",
  "Saved in Downloads": "In Downloads gespeichert",
  "Saving files needs Android 10 or newer": "Zum Speichern von Dateien ist Android 10 oder neuer nötig",
  "Scan a ticket with your scanner.": "Scannen Sie ein Ticket mit Ihrem Scanner.",
  "Scan for {n} show": "Für {n} Vorstellung scannen",
  "Scan for {n} shows": "Für {n} Vorstellungen scannen",
  "Scan for {n} start time": "Für {n} Startzeit scannen",
  "Scan for {n} start times": "Für {n} Startzeiten scannen",
  "Scan tickets": "Tickets scannen",
  "Search": "Suche",
  "Search by name": "Suche nach Namen",
  "Search conversations": "Unterhaltungen durchsuchen",
  "Search shows": "Vorstellungen suchen",
  "Seat": "Sitzplatz",
  "Seat {seat}": "Platz {seat}",
  "See all": "Alle anzeigen",
  "Sell, check tickets and answer customers in Johku App.": "Verkaufen, Tickets prüfen und Kunden antworten in der Johku App.",
  "Send": "Senden",
  "Send as": "Senden als",
  "Send code": "Code senden",
  "Send messages and start conversations as you": "In deinem Namen Nachrichten senden und Unterhaltungen beginnen",
  "Send now": "Jetzt senden",
  "Send the offer": "Angebot senden",
  "Send to members": "An Mitglieder senden",
  "Send to shops": "An die Shops senden",
  "Send update": "Update senden",
  "Sending…": "Wird gesendet…",
  "Sent to {done} of {n} people": "An {done} von {n} Personen gesendet",
  "Sent to {done} of {n} person": "An {done} von {n} Person gesendet",
  "Severity": "Schweregrad",
  "Shop": "Shop",
  "Show booking": "Buchung anzeigen",
  "Show conversations of": "Unterhaltungen anzeigen von",
  "Show more": "Mehr anzeigen",
  "Show orders of": "Bestellungen anzeigen von",
  "Show the code at the door.": "Zeigen Sie den Code am Eingang.",
  "Show the code at the till, or type it in the shop's online store.": "Zeigen Sie den Code an der Kasse oder geben Sie ihn im Onlineshop des Shops ein.",
  "Show tickets": "Tickets anzeigen",
  "Show used and expired codes": "Benutzte und abgelaufene Codes anzeigen",
  "Shows": "Vorstellungen",
  "Sign in": "Anmelden",
  "Sign in again": "Erneut anmelden",
  "Sign in to Johku Hub": "Bei Johku Hub anmelden",
  "Sign in with an email code": "Mit E-Mail-Code anmelden",
  "Sign in with Johku": "Mit Johku anmelden",
  "Sign out": "Abmelden",
  "Sign out of {email}? Its messages are removed from this device.": "Von {email} abmelden? Die Nachrichten des Kontos werden von diesem Gerät entfernt.",
  "Sign out of this account": "Von diesem Konto abmelden",
  "Sign out?": "Abmelden?",
  "Signing in with Johku didn't finish. Please try again.": "Die Anmeldung mit Johku wurde nicht abgeschlossen. Bitte versuchen Sie es erneut.",
  "Signing in with Johku didn't work ({error}).": "Die Anmeldung mit Johku hat nicht funktioniert ({error}).",
  "Signing in…": "Anmeldung läuft…",
  "So you see customers' questions right away": "Damit Sie Kundenfragen sofort sehen",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Einige Shops haben nicht geantwortet, daher können deren Codes fehlen: {shops}",
  "Someone": "Jemand",
  "Something went wrong.": "Etwas ist schiefgelaufen.",
  "Something went wrong. Please try again.": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  "Something went wrong. Try again in a moment.": "Etwas ist schiefgelaufen. Versuchen Sie es gleich noch einmal.",
  "Sounds": "Töne",
  "Start the conversation": "Unterhaltung beginnen",
  "Start times today": "Startzeiten heute",
  "Status": "Status",
  "Subject (optional)": "Betreff (optional)",
  "Support": "Support",
  "Swipe for the next one": "Wischen für das nächste",
  "Switch camera": "Kamera wechseln",
  "Switch shop": "Shop wechseln",
  "That code has expired. Ask for a new one.": "Dieser Code ist abgelaufen. Fordern Sie einen neuen an.",
  "That code isn't right. Check it and try again.": "Dieser Code ist nicht richtig. Prüfen Sie ihn und versuchen Sie es erneut.",
  "That didn't go through. Try again in a moment.": "Das hat nicht geklappt. Versuchen Sie es gleich noch einmal.",
  "The booking isn't confirmed.": "Die Buchung ist nicht bestätigt.",
  "The camera didn't start.": "Die Kamera ist nicht gestartet.",
  "The code is on its way. Check again in a moment.": "Der Code ist unterwegs. Sehen Sie gleich noch einmal nach.",
  "The conversation was declined.": "Die Unterhaltung wurde abgelehnt.",
  "The device's language": "Sprache des Geräts",
  "The download failed": "Der Download ist fehlgeschlagen",
  "The file is larger than 20 MB": "Die Datei ist größer als 20 MB",
  "The Johku team": "Das Johku-Team",
  "The Johku team keeps you posted here until it's resolved.": "Das Johku-Team hält dich hier auf dem Laufenden, bis es behoben ist.",
  "The order page can't be opened right now. Try again in a moment.": "Die Bestellseite kann gerade nicht geöffnet werden. Versuchen Sie es gleich noch einmal.",
  "The PIN code and instructions show from {time}.": "Der PIN-Code und die Hinweise werden ab {time} angezeigt.",
  "The shop can't be reached about this order from here. Try its order page.": "Der Shop ist zu dieser Bestellung hier nicht erreichbar. Versuchen Sie es über die Bestellseite.",
  "The ticket couldn't be confirmed. Scan it again.": "Das Ticket konnte nicht bestätigt werden. Scannen Sie es erneut.",
  "The ticket is for {what}.": "Das Ticket gilt für {what}.",
  "The ticket is for another place.": "Das Ticket gilt für einen anderen Ort.",
  "The ticket is for another shop.": "Das Ticket gehört zu einem anderen Shop.",
  "The ticket is for another show.": "Das Ticket gilt für eine andere Vorstellung.",
  "The ticket is for another time.": "Das Ticket gilt für eine andere Zeit.",
  "The tickets can't be opened right now. Try again in a moment.": "Die Tickets können gerade nicht geöffnet werden. Versuchen Sie es gleich noch einmal.",
  "There's no one {name} can write to yet.": "Es gibt noch niemanden, an den {name} schreiben kann.",
  "These tickets aren't available any more.": "Diese Tickets sind nicht mehr verfügbar.",
  "this account": "dieses Konto",
  "This browser can't read codes with the camera. Use the Johku Hub app, or a scanner (settings).": "Dieser Browser kann keine Codes mit der Kamera lesen. Verwenden Sie die App Johku Hub oder einen Scanner (Einstellungen).",
  "This device has no camera.": "Dieses Gerät hat keine Kamera.",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Das geht jetzt an das Personal von {n} Shop, per Push und E-Mail. Senden?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Das geht jetzt an das Personal von {n} Shops, per Push und E-Mail. Senden?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Das geht jetzt an das Personal aller Shops, per Push und E-Mail. Senden?",
  "This incident isn't shown any more.": "Diese Störung wird nicht mehr angezeigt.",
  "This order has been cancelled. Its tickets aren't valid.": "Diese Bestellung wurde storniert. Ihre Tickets sind nicht gültig.",
  "This order has been refunded. Its tickets aren't valid.": "Diese Bestellung wurde erstattet. Ihre Tickets sind nicht gültig.",
  "Ticket": "Ticket",
  "Ticket {n} of {total}": "Ticket {n} von {total}",
  "Tickets": "Tickets",
  "Tickets at hand": "Tickets immer dabei",
  "To (email)": "An (E-Mail)",
  "To members": "An Mitglieder",
  "To the members of {collection}: {n} member": "An die Mitglieder von {collection}: {n} Mitglied",
  "To the members of {collection}: {n} members": "An die Mitglieder von {collection}: {n} Mitglieder",
  "To the members of {collection}: sending, {sent}/{n}": "An die Mitglieder von {collection}: wird gesendet, {sent}/{n}",
  "Today": "Heute",
  "Tomorrow": "Morgen",
  "Total": "Insgesamt",
  "Try again": "Erneut versuchen",
  "Turn on notifications": "Benachrichtigungen einschalten",
  "Unpaid": "Unbezahlt",
  "Upcoming": "Kommende",
  "Update to the shops": "Update an die Shops",
  "Use a scanner instead of the camera": "Scanner statt Kamera verwenden",
  "Use another address": "Andere Adresse verwenden",
  "Used": "Verwendet",
  "Uses": "Verwendungen",
  "Valid from {date}": "Gültig ab {date}",
  "Valid until {date}": "Gültig bis {date}",
  "Validity": "Gültigkeit",
  "Value left": "Restwert",
  "Venue": "Ort",
  "Vibration": "Vibration",
  "Waiting for {shop} to accept the conversation.": "Warten darauf, dass {shop} die Unterhaltung annimmt.",
  "Waiting for an answer": "Wartet auf Antwort",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Wir senden Ihnen einen Anmeldecode per E-Mail. Verwenden Sie die Adresse, die Sie bei Johku nutzen.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Was nicht funktioniert, wen es betrifft und was man in der Zwischenzeit tun kann.",
  "What you offer, and what kind of partners you look for": "Was ihr anbietet und welche Partner ihr sucht",
  "What's wrong": "Was ist los",
  "When": "Wann",
  "When something in Johku doesn't work, and when it's fixed": "Wenn etwas bei Johku nicht funktioniert, und wenn es behoben ist",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "Wenn Sie in einem Johku-Shop mit {email} einkaufen, erscheint die Bestellung automatisch hier.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "Wenn Sie in einem Johku-Shop mit Ihrer E-Mail-Adresse einkaufen, erscheint die Bestellung automatisch hier.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Ob andere Johku-Händler deinen Shop finden und ihn zu einer Unterhaltung einladen können",
  "With the customer": "Mit dem Kunden",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Mit Ihrer E-Mail, Google oder Microsoft, wie in den Johku-Onlineshops.",
  "Withdraw the offer": "Angebot zurückziehen",
  "Withdrawn": "Zurückgezogen",
  "Withdrew the offer.": "Hat das Angebot zurückgezogen.",
  "Write a message": "Nachricht schreiben",
  "Write to the customer": "An den Kunden schreiben",
  "Write to the shop": "An den Shop schreiben",
  "Yesterday": "Gestern",
  "You": "Sie",
  "You can close this page.": "Du kannst diese Seite schließen.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Du erhältst diese Nachricht, weil du in einem Shop arbeitest, der Johku nutzt. Verfolge die Lage in der Johku-App oder unter {url}.",
  "You: ": "Sie: ",
  "You'll see replies without opening the app.": "Sie sehen Antworten, ohne die App zu öffnen.",
  "You're offline. A new conversation needs a connection.": "Sie sind offline. Für eine neue Unterhaltung ist eine Verbindung nötig.",
  "You're offline. Checking in and out needs a connection.": "Sie sind offline. Ein- und Auschecken braucht eine Verbindung.",
  "You're offline. The first message needs a connection.": "Sie sind offline. Für die erste Nachricht ist eine Verbindung nötig.",
  "You're offline. Try again when the connection returns.": "Keine Verbindung. Versuche es erneut, wenn die Verbindung wieder da ist.",
  "You're staff at {shop}": "Sie arbeiten bei {shop}",
  "Your codes can't be loaded right now. Try again in a moment.": "Ihre Codes können gerade nicht geladen werden. Versuchen Sie es gleich noch einmal.",
  "Your conversations with shops about your orders show up here.": "Ihre Unterhaltungen mit Shops über Ihre Bestellungen erscheinen hier.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Ihr Johku-Konto hat noch keinen Zugang zu Johku Hub.",
  "Your Johku Hub sign-in code is {code}.": "Ihr Johku Hub-Anmeldecode ist {code}.",
  "Your orders": "Ihre Bestellungen",
  "Your orders can't be loaded right now. Try again in a moment.": "Ihre Bestellungen können gerade nicht geladen werden. Versuchen Sie es gleich noch einmal.",
  "Your other accounts stay signed in.": "Ihre anderen Konten bleiben angemeldet.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "Ihre anderen Konten bleiben angemeldet. Wechseln Sie zwischen ihnen über Ihr Bild auf der Startseite.",
  "Your session for {account} has ended. Please sign in again.": "Ihre Sitzung für {account} ist abgelaufen. Bitte melden Sie sich erneut an.",
  "Your shop": "Ihr Shop",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Dein Shop hat keinen Vertriebskanal in Johku. Richte zuerst einen in den Einstellungen der Johku-App ein.",
  "Your shops": "Ihre Shops",
  "Your tickets will show up here": "Ihre Tickets erscheinen hier",
  "Your tickets, orders and messages with shops": "Ihre Tickets, Bestellungen und Nachrichten mit Shops"
}
